// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"125":"2455815c","366":"2802215b","488":"92190665","849":"d7f684f4","998":"97af7eaf"}[chunkId] + ".chunk.js";
};